import React, { useState, useEffect } from "react";
import config from "config";
import { Link } from "react-router-dom";
import StoreFrontLink from "../components/Sidebar/StoreFrontLink";
import { XoxodayLongLogo } from "../components/Icons";

import { STORAGE, makeRequestAuth } from "../utils/globals";
import BulkUploadProgress from "./BulkProcess/BulkUploadProgress";
import axios from "axios";
import styled from "styled-components";
import ProfileService from "../services/profileService";
import { NavLink } from "react-router-dom";
import navList from "../config/navList";
import {
  MODULE_ACL_SWITCH,
  ACL_MODULE_MAPPING,
} from "../constants/RouteConstant";
import { app_path } from "config";
import {
  Icon,
  IconButton,
  Popover as initialPopover,
  Button,
  Typography,
  Tooltip,
  Chip,
} from "@plum-xoxo/admin-dsm";
import theme from "../theme/theme";
import { useLocation } from "react-router-dom";

const StyledTypography = styled(Typography.H3).attrs()`
  white-space: nowrap;
  color: ${(props) => props.theme.palette.dark.c200};
  padding: 12px;
  border-radius: 4px;
  font-size: 14px;
  &:hover {
    color: ${(props) => props.theme.palette.dark.c300};
  }
`;
const StyledNavLink = styled(NavLink).attrs()`
  white-space: nowrap;
  &.active {
    background: ${(props) => props.theme.palette.primary.c00};
    h3 {
      color: ${(props) => props.theme.palette.primary.c04};
    }
    border-radius: 4px;
  }
  ${StyledTypography}&:hover {
    color: ${(props) => props.theme.palette.dark.c300};
  }
`;

const Popover = styled(initialPopover).attrs()`
  overflow: scroll;
  .eui-option-child {
    font-weight: 400 !important;
  }
`;

const CustomPopoverHoverBackground = styled(Typography).attrs()`
 .eui-option-inner{
  padding-top:12px ;
  padding-bottom:12px ;
 }
 .eui-option-inner:hover{
    background-color: ${(props) => props.theme.palette.light.c100};
},`;

const StyledPrimaryBanckGrounddDiv = styled.div`
  background-color: ${(props) => props.theme.palette.primary.c05};
  height: 40px;
  margin: 0px;
`;

const StyledWarningBackgroundDiv = styled.div`
  background-color: ${(props) => props.theme.palette.warning.c05};
  height: 40px;
  margin: 0px;
`;

const StyledChip = styled(Chip).attrs()`
  height: 24px;
  justify-content: center;

  border: 1px solid
    ${(props) =>
      props.theme.palette[props?.backgroundColor]
        ? props.backgroundColor
          ? props?.backgroundColor === "primary"
            ? props.theme.palette[props?.backgroundColor].c01
            : props?.backgroundColor === "light"
            ? props.theme.palette[props?.backgroundColor].c300
            : props.theme.palette[props?.backgroundColor].c100
          : ""
        : ""};
`;

const KybMessage = (props) => {
  const { kybStatus, history } = props;
  return (
    <>
      {kybStatus === 0 ? (
        <StyledPrimaryBanckGrounddDiv className="fixed-top d-flex justify-content-center align-items-center">
          <Typography.BodySmall component="div" color="dark" shade="c200">
            Business verification is pending.{" "}
            <Link to={`/${app_path}/accounts/platform-preferences`}>
              <Typography.BodySmall
                component="span"
                color="primary"
                shade="c02"
                className="cursor-pointer"
              >
                {" "}
                Verify{" "}
              </Typography.BodySmall>{" "}
            </Link>
            to get full access to Plum platform.
          </Typography.BodySmall>
        </StyledPrimaryBanckGrounddDiv>
      ) : kybStatus === 1 ? (
        <StyledWarningBackgroundDiv className="fixed-top d-flex justify-content-center align-items-center">
          <Typography.BodySmall component="div" color="dark" shade="c200">
            Business verification is being processed. You will get full access
            to Plum platform after verification.
          </Typography.BodySmall>
        </StyledWarningBackgroundDiv>
      ) : kybStatus === 3 || kybStatus === 5 ? (
        <StyledWarningBackgroundDiv className="fixed-top d-flex justify-content-center align-items-center">
          <Typography.BodySmall component="div" color="dark" shade="c200">
            Unable to verify your business details.{" "}
            <Link to={`/${app_path}/accounts/platform-preferences`}>
              <Typography.BodySmall
                component="span"
                color="blue"
                shade="c200"
                className="cursor-pointer"
              >
                {" "}
                Resubmit for verification{" "}
              </Typography.BodySmall>{" "}
            </Link>
            to get full access to Plum platform.{" "}
          </Typography.BodySmall>
        </StyledWarningBackgroundDiv>
      ) : null}
    </>
  );
};

const Header = (props) => {
  const [accounts, setAccounts] = useState([]);
  const [getMenuLoader, setGetMenuLoader] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const fetchAccounts = async () => {
    const url = `${config.auth_url}/switchapi/fetch_accounts`;
    const payload = {};
    const headers = {
      "Content-Type": "application/json",
      pltfm: 4,
      lng: "en",
    };
    try {
      const { data } = await axios(url, {
        method: "post",
        data: payload,
        withCredentials: true,
        headers: headers,
      });
      setAccounts(data.linkedAccounts);
    } catch (error) {
      console.log(error);
      return error;
    }
  };
  const location = useLocation();
  const pathname = location.pathname;
  useEffect(() => {
    fetchAccounts();
  }, []);

  const accountLogout = () => {
    setIsLoading(true);
    makeRequestAuth(
      {},
      function () {
        STORAGE("jose", "", 1);
        STORAGE("login_email", "", 1);
        STORAGE("e_login", "", 1);
        STORAGE("e_points", "", 1);
        STORAGE("member_id", "", 1);
        STORAGE("logo_url", "", true);

        let delete_params = STORAGE("delete_params")
          ? STORAGE("delete_params").split(",")
          : [];
        for (var i = 0; i < delete_params.length; i++) {
          STORAGE(delete_params[i], "", 1);
        }
        STORAGE("delete_params", "", 1);
        sessionStorage.removeItem("xoxoPointsState");
        sessionStorage.removeItem("xoxoCodeState");
        sessionStorage.removeItem("xoxoLinkState");
        sessionStorage.removeItem("AutomationCreationData");
        setIsLoading(false);
        window.location.href = config.storeFrontURL;
      }.bind(this),
      {},
      "/logout"
    );
  };
  const checkAccountIsLogin = () => {
    ProfileService.getMenu()
      .then((response) => {
        setGetMenuLoader(false);
        if (response && response.success === 1) {
          props.updateUserAndCompanyType(response.data || {});
        } else {
          window.location.href = config.storeFrontURL;
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const {
    companyDetails: { company_primary_logo } = {},
    employeeDetails: {
      domain = "",
      employee_first_name = "",
      employee_full_name = "",
    } = {},
    employeeDetails = {},
    showNotificationBar,
  } = props;
  const moduleAcl = props.accountReducer.moduleAcl || [];
  const awardCheck = 0;
  let moduleAclArray = moduleAcl.map((item) => item.module_id);
  !moduleAclArray.includes(ACL_MODULE_MAPPING.CAMPAIGN) &&
  moduleAclArray.includes(ACL_MODULE_MAPPING.XOXO_LINK)
    ? moduleAclArray.push(ACL_MODULE_MAPPING.CAMPAIGN)
    : null;

  let url = config.storeFrontURL.replace(/\/$/g, "");
  let temp_logo = <XoxodayLongLogo width="auto" height="40" />;

  const kybStatus = props?.accountReducer?.kybStatus?.kyb_status;
  return (
    <>
      <KybMessage kybStatus={kybStatus} history={props.history} />
      <nav
        className="navbar fixed-top"
        style={{
          marginTop:
            kybStatus === 0 ||
            kybStatus === 1 ||
            kybStatus === 3 ||
            kybStatus === 5
              ? "40px"
              : 0,
          backgroundColor: theme.palette.light.c000,
        }}
      >
        <div className="container-fluid p-0" style={{ position: "relative" }}>
          <a href={`/${app_path}/dashboard`} className="mr-28">
            <div className="plum-brand">
              {company_primary_logo !== "" ? (
                <img className="logo img-fluid" src={company_primary_logo} />
              ) : (
                temp_logo
              )}
            </div>
          </a>
          <>
            {navList.map((data, index) => {
              if (
                data.moduleId !== "AWARD" &&
                MODULE_ACL_SWITCH === true &&
                !moduleAclArray.includes(data.moduleId) &&
                !(data.name === "Send Rewards") &&
                data.name != "Home" &&
                data.name != "Integrations"
              ) {
                return;
              }

              //for award
              if (data.moduleId == "AWARD" && awardCheck == 0) {
                return;
              }
              const isOnlyPointsActivate =
                !moduleAclArray.includes(ACL_MODULE_MAPPING.XOXO_LINK) &&
                !moduleAclArray.includes(ACL_MODULE_MAPPING.XOXO_VOUCHER) &&
                moduleAclArray.includes(ACL_MODULE_MAPPING.XOXO_POINT);
              const isStoreFrontIntegrationClient = moduleAclArray.includes(
                ACL_MODULE_MAPPING.STOREFRONT_INTEGRATION
              );
              if (
                data.name === "Campaigns" &&
                isOnlyPointsActivate &&
                !isStoreFrontIntegrationClient
              ) {
                return;
              }
              if (
                data.name === "Send Rewards" &&
                (moduleAclArray.includes(ACL_MODULE_MAPPING.XOXO_VOUCHER) ||
                  moduleAclArray.includes(ACL_MODULE_MAPPING.XOXO_LINK) ||
                  moduleAclArray.includes(ACL_MODULE_MAPPING.XOXO_POINT) ||
                  moduleAclArray.includes(ACL_MODULE_MAPPING.PLUM_PRO))
              ) {
                const isRewardRoute =
                  pathname === `/${app_path}/xoxo-points/` ||
                  pathname === `/${app_path}/xoxo-code/` ||
                  pathname === `/${app_path}/xoxo-link/` ||
                  pathname === `/${app_path}/generate-brand-voucher/`;

                const link = moduleAclArray.includes(
                  ACL_MODULE_MAPPING.XOXO_POINT
                )
                  ? `/${app_path}/xoxo-points/`
                  : moduleAclArray.includes(ACL_MODULE_MAPPING.XOXO_VOUCHER)
                  ? `/${app_path}/xoxo-code/`
                  : moduleAclArray.includes(ACL_MODULE_MAPPING.XOXO_LINK)
                  ? `/${app_path}/xoxo-link/`
                  : moduleAclArray.includes(ACL_MODULE_MAPPING.XOXO_POINT)
                  ? `/${app_path}/xoxo-points/`
                  : moduleAclArray.includes(ACL_MODULE_MAPPING.PLUM_PRO)
                  ? `/${app_path}/generate-brand-voucher/`
                  : `/${app_path}/xoxo-code/`;
                return (
                  <StyledNavLink
                    onClick={checkAccountIsLogin}
                    to={link}
                    activeClassName="active"
                    isActive={() => isRewardRoute}
                    key={index}
                  >
                    <div>
                      <StyledTypography id="header-send-rewards-title">
                        <Typography.ButtonText>
                          {data.name}
                        </Typography.ButtonText>
                      </StyledTypography>
                    </div>
                  </StyledNavLink>
                );
              } else if (
                data.name === "Send Rewards" &&
                !(
                  moduleAclArray.includes(ACL_MODULE_MAPPING.XOXO_VOUCHER) ||
                  moduleAclArray.includes(ACL_MODULE_MAPPING.XOXO_LINK) ||
                  moduleAclArray.includes(ACL_MODULE_MAPPING.XOXO_POINT) ||
                  moduleAclArray.includes(ACL_MODULE_MAPPING.PLUM_PRO)
                )
              ) {
                return;
              }

              // if (data.subModules) {
              //   return (
              //     <SideBarSubNav
              //       key={index}
              //       {...this.props}
              //       navInfo={data}
              //       checkAccountIsLogin={this.checkAccountIsLogin}
              //     />
              //   );
              // }
              if (data.name === "Integrations") {
                const isRewardRoute = pathname?.includes(
                  `/${app_path}/integration`
                );
                return (
                  <StyledNavLink
                    onClick={checkAccountIsLogin}
                    to={data.link}
                    activeClassName="active"
                    isActive={() => isRewardRoute}
                    key={index}
                  >
                    <div>
                      <StyledTypography>
                        <Typography.ButtonText id="header-integration-title">
                          {data.name}
                        </Typography.ButtonText>
                      </StyledTypography>
                    </div>
                  </StyledNavLink>
                );
              }

              return (
                <StyledNavLink
                  onClick={checkAccountIsLogin}
                  to={data.link}
                  activeClassName="active"
                  key={index}
                >
                  <div>
                    <StyledTypography>
                      <Typography.ButtonText id={`header-${data.name}-title`}>
                        {data.name}
                      </Typography.ButtonText>
                    </StyledTypography>
                  </div>
                </StyledNavLink>
              );
            })}

            {/* <li className="nav-item noHover sidebar-intgrstion-title mt-3">
          <a style={{ fontSize: "12px" }} className="nav-link">
            Manage Integrations
          </a>
        </li> */}
            {/* {allIntegrations.map((data, index) => {
              if (data.moduleId != "manage_integrations") {
                if (
                  activeIntegration.filter((i) => i.app_code == data.moduleId)
                    .length == 0
                ) {
                  return;
                }
              }
              return (
                <NavLink
                  onClick={this.checkAccountIsLogin}
                  to={data.link}
                  activeClassName="active"
                  key={index}
                >
                  <div>
                    <StyledTypography>{data.name}</StyledTypography>
                  </div>
                </NavLink>
              );
            })} */}
            {/* <Typography className="m-0">
              <a
                href="https://helpcenter.xoxoday.com/docs/getting-started"
                target="_blank"
                rel="noreferrer"
              >
                <StyledTypography>
                  <Typography.ButtonText id="header-support-title">
                    Support
                  </Typography.ButtonText>
                </StyledTypography>
              </a>
            </Typography> */}
          </>
          {/* <div>
            <StyledTypography className="active">Home</StyledTypography>
          </div>
          <div>
            <StyledTypography>Distribution</StyledTypography>
          </div>
          <div>
            <StyledTypography>Campaign</StyledTypography>
          </div>
          <div>
            <StyledTypography>Recharge</StyledTypography>
          </div>
          <div>
            <StyledTypography>Repors</StyledTypography>
          </div>
          <div>
            <StyledTypography>Settings</StyledTypography>
          </div>
          <div>
            <StyledTypography>Integration</StyledTypography>
          </div> */}

          {config.festiveGifting && (
            <div>
              <Popover
                trigger="hover"
                onOverlayClick={() => {}}
                onVisibilityChange={function noRefCheck() {}}
                content={
                  <CustomPopoverHoverBackground className="mb-0">
                    <Popover.Options>
                      <a
                        href={`https://survey.typeform.com/to/edPxSmF1`}
                        target="_blank"
                        className="d-flex"
                        rel="noreferrer"
                      >
                        <Typography component="span" className="ml-12">
                          <Typography
                            component="div"
                            color="dark"
                            shade="c300"
                            className="whitespace-nowrap text-left"
                          >
                            Diwali Gifting
                          </Typography>
                          <Typography.BodySmall
                            color="dark"
                            shade="c200"
                            className="mb-0 text-left"
                          >
                            Send gifts for occasion of Diwali
                          </Typography.BodySmall>
                        </Typography>
                        <IconButton
                          variant="plain"
                          color="primary"
                          className="ml-20 align-items-center h-100"
                          size="16"
                        >
                          <Icon
                            color="dark"
                            shade="c200"
                            size="16"
                            iconName="PlumLink"
                          />
                        </IconButton>
                      </a>
                    </Popover.Options>
                    <Popover.Options>
                      <div className="d-flex cursor-not-allowed">
                        <Typography component="span" className="ml-12">
                          <Typography
                            component="div"
                            color="dark"
                            shade="c100"
                            className="whitespace-nowrap text-left"
                          >
                            Christmas
                          </Typography>
                          <Typography.BodySmall
                            color="dark"
                            shade="c100"
                            className="mb-0 text-left"
                          >
                            Coming Soon
                          </Typography.BodySmall>
                        </Typography>
                      </div>
                    </Popover.Options>
                    <Popover.Options>
                      <div className="d-flex cursor-not-allowed">
                        <Typography component="span" className="ml-12">
                          <Typography
                            component="div"
                            color="dark"
                            shade="c100"
                            className="whitespace-nowrap text-left"
                          >
                            New Year
                          </Typography>
                          <Typography.BodySmall
                            color="dark"
                            shade="c100"
                            className="mb-0 text-left"
                          >
                            Coming Soon
                          </Typography.BodySmall>
                        </Typography>
                      </div>
                    </Popover.Options>
                  </CustomPopoverHoverBackground>
                }
                placement="bottom-end"
                offset={[0, 0]}
                // width={260}
                className="popover-placement p-12"
              >
                <StyledTypography>
                  <Typography.ButtonText
                    id={`festive-reward-title`}
                    className="cursor-pointer mr-24"
                  >
                    Festive Gifting
                    <Typography.BodySmall
                      color="green"
                      shade="c300"
                      className="position-absolute ml-4"
                      style={{ top: "7px" }}
                      component="span"
                    >
                      New
                    </Typography.BodySmall>
                  </Typography.ButtonText>
                </StyledTypography>
              </Popover>
            </div>
          )}

          {config.exclusive && (
            <div>
              <Popover
                trigger="hover"
                // overlay={true}
                onOverlayClick={() => {}}
                onVisibilityChange={function noRefCheck() {}}
                content={
                  <CustomPopoverHoverBackground className="mb-0">
                    <Popover.Options>
                      <a
                        href={`https://survey.typeform.com/to/Pna2npx8#hubspot_utk=xxxxx&hubspot_page_name=xxxxx&hubspot_page_url=xxxxx`}
                        target="_blank"
                        className="d-flex"
                        rel="noreferrer"
                      >
                        <Typography component="span" className="ml-12">
                          <Typography
                            component="div"
                            color="dark"
                            shade="c300"
                            className="whitespace-nowrap text-left"
                          >
                            ICC Cricket World Cup 2023
                          </Typography>
                          <Typography.BodySmall
                            color="dark"
                            shade="c200"
                            className="mb-0 text-left"
                          >
                            Book tickets for the upcoming <br></br> Cricket
                            World Cup.
                          </Typography.BodySmall>
                        </Typography>
                        <IconButton
                          variant="plain"
                          color="primary"
                          className="ml-20 align-items-center h-100"
                          size="16"
                        >
                          <Icon
                            color="dark"
                            shade="c200"
                            size="16"
                            iconName="PlumLink"
                          />
                        </IconButton>
                      </a>
                    </Popover.Options>
                    <Popover.Options>
                      <div className="d-flex cursor-not-allowed">
                        <Typography component="span" className="ml-12">
                          <Typography
                            component="div"
                            color="dark"
                            shade="c100"
                            className="whitespace-nowrap text-left"
                          >
                            Team Building Activity
                          </Typography>
                          <Typography.BodySmall
                            color="dark"
                            shade="c100"
                            className="mb-0 text-left"
                          >
                            Coming Soon
                          </Typography.BodySmall>
                        </Typography>
                      </div>
                    </Popover.Options>
                  </CustomPopoverHoverBackground>
                }
                placement="bottom-end"
                offset={[0, 0]}
                // width={260}
                className="popover-placement p-12"
              >
                <StyledTypography>
                  <Typography.ButtonText
                    id={`festive-reward-title`}
                    className="cursor-pointer"
                  >
                    Exclusive
                    <Typography.BodySmall
                      color="green"
                      shade="c300"
                      className="position-absolute ml-4"
                      style={{ top: "7px" }}
                      component="span"
                    >
                      New
                    </Typography.BodySmall>
                  </Typography.ButtonText>
                </StyledTypography>
              </Popover>
            </div>
          )}

          {showNotificationBar ? (
            <BulkUploadProgress
              client_id={props?.accountReducer?.clientId || ""}
            />
          ) : null}
          <>
            <div className="btn-group p-0 profile-nav d-flex align-items-center">
              <StyledNavLink
                onClick={checkAccountIsLogin}
                to={`/${app_path}/accounts/platform-preferences`}
              >
                <div className="px-10 py-8">
                  <Tooltip
                    offset={[5, 10]}
                    placement="bottom"
                    tooltip="Settings"
                  >
                    <Icon
                      color={
                        pathname ===
                        `/${app_path}/accounts/platform-preferences`
                          ? "primary"
                          : "dark"
                      }
                      shade={
                        pathname ===
                        `/${app_path}/accounts/platform-preferences`
                          ? "c02"
                          : "c200"
                      }
                      iconName="Setting"
                      size={19}
                    />
                  </Tooltip>
                </div>
              </StyledNavLink>
              <a
                href="https://helpcenter.xoxoday.com/docs/getting-started"
                target="_blank"
                rel="noreferrer"
              >
                <Tooltip offset={[7, 10]} placement="bottom" tooltip="Support">
                  <Icon
                    color="dark"
                    shade="c200"
                    iconName="Help"
                    size={20}
                    className="ml-18"
                  />
                </Tooltip>
              </a>
              <div className="ml-12">
                <Popover
                  trigger="hover"
                  // overlay={true}
                  onOverlayClick={() => {}}
                  onVisibilityChange={function noRefCheck() {}}
                  content={
                    <CustomPopoverHoverBackground className="mb-0">
                      <Popover.Options>
                        <Link
                          to={`/${app_path}/accounts/profile`}
                          className="d-flex"
                        >
                          <span className="name-initial">
                            {employee_first_name &&
                            employee_first_name.length &&
                            employee_first_name.charAt(0)
                              ? employee_first_name.charAt(0)
                              : ""}{" "}
                          </span>
                          <Typography component="span" className="ml-12">
                            <Typography
                              component="div"
                              color="dark"
                              shade="c300"
                              className="whitespace-nowrap text-left"
                            >
                              {employee_first_name
                                ? employee_full_name.charAt(0).toUpperCase() +
                                  employee_full_name.substring(1, 12)
                                : ""}
                              {employee_full_name?.length > 12 ? "..." : ""}
                            </Typography>
                            <Typography
                              color="dark"
                              shade="c200"
                              className="mb-0 text-left"
                            >
                              {props.accountReducer.typeData?.role === 1
                                ? "Super Admin"
                                : "Admin"}
                            </Typography>
                          </Typography>
                          <IconButton
                            variant="plain"
                            color="primary"
                            className="ml-12"
                          >
                            <Icon iconName="RightArrow" />
                          </IconButton>
                        </Link>
                      </Popover.Options>
                      <hr className="mt-0 mb-0" />
                      <Popover.Options className="mt-4">
                        <StoreFrontLink employeeDetails={employeeDetails} />
                      </Popover.Options>
                      {accounts.length > 1 ? (
                        <Popover.Options className="mt-4">
                          <a
                            className="switch-store-linkX"
                            href={`${url}/${domain}/switch-account`}
                          >
                            <Typography component="div" className="d-flex">
                              <Icon
                                color="dark"
                                shade="c200"
                                iconName="PlumList"
                                size={16}
                              />
                              <Typography.LabelText
                                id="header-account-dropdown-switch-account-link"
                                component="span"
                                color="dark"
                                shade="c300"
                                className="ml-16"
                              >
                                Switch Account
                                <Typography.BodySmall
                                  component="div"
                                  color="dark"
                                  shade="c200"
                                >
                                  {employee_full_name}
                                </Typography.BodySmall>
                                {/* {config.storeFrontURL.replace(/\/$/g, "")} */}
                              </Typography.LabelText>
                            </Typography>
                          </a>
                        </Popover.Options>
                      ) : null}
                      <Popover.Options onClick={accountLogout} className="mt-4">
                        <Typography.LabelText
                          component="span"
                          color={theme.palette.red.c200}
                        >
                          <Icon
                            color="red"
                            shade="c200"
                            iconName="PlumLogOut"
                            size={16}
                          />
                          <Typography.BodySmall
                            id="header-account-dropdown-logout-link"
                            component="span"
                            color={theme.palette.red.c200}
                            style={theme.typography.label}
                            className="ml-16"
                          >
                            Logout
                          </Typography.BodySmall>
                        </Typography.LabelText>
                      </Popover.Options>
                    </CustomPopoverHoverBackground>
                  }
                  placement="bottom-end"
                  offset={[0, 0]}
                  // width={260}
                  className="popover-placement p-12"
                >
                  <Button className="d-flex align-items-center" variant="plain">
                    <Typography
                      component="div"
                      className="d-flex align-items-center"
                    >
                      <span className="name-initial">
                        {employee_first_name &&
                        employee_first_name.length &&
                        employee_first_name.charAt(0)
                          ? employee_first_name.charAt(0)
                          : ""}{" "}
                      </span>
                    </Typography>
                  </Button>
                </Popover>
              </div>
            </div>
          </>
        </div>
      </nav>
    </>
  );
};

export default Header;

// Header.propTypes = {
// 	companyDetails: PropTypes.object.isRequired,
// 	employeeDetails: PropTypes.object.isRequired
// };
